import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Waveform, SignOut, UserCircle } from "@phosphor-icons/react";

const Navbar = () => {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  const handleLogout = () => {
    logout();
    nav("/");
  };

  return (
    <header className="sticky top-0 z-50 glass">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2 group">
          <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-[#E11D48] to-[#7A0E2A] flex items-center justify-center glow-primary">
            <Waveform weight="fill" size={20} className="text-white" />
          </div>
          <span className="font-display font-black text-xl tracking-tight">
            XooKmédia
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm text-zinc-300">
          <Link to="/concerts" data-testid="nav-concerts" className="hover:text-white transition-colors">Concerts</Link>
          <Link to="/studio" data-testid="nav-studio" className="hover:text-white transition-colors">Studio IA</Link>
          <Link to="/support" data-testid="nav-support" className="hover:text-white transition-colors">Assistance</Link>
          <Link to="/install" data-testid="nav-install" className="hover:text-[#E11D48] transition-colors">App</Link>
          {user?.role === "artist" && (
            <>
              <Link to="/dashboard" data-testid="nav-dashboard" className="hover:text-white transition-colors">Tableau de bord</Link>
              <Link to="/contract" data-testid="nav-contract" className="hover:text-white transition-colors">Mon contrat</Link>
            </>
          )}
          {user?.role === "admin" && (
            <Link to="/admin" data-testid="nav-admin" className="hover:text-[#F59E0B] transition-colors text-[#F59E0B]">Console admin</Link>
          )}
        </nav>

        <div className="flex items-center gap-3">
          {user ? (
            <>
              <span className="hidden sm:flex items-center gap-2 text-sm text-zinc-300">
                <UserCircle size={20} />
                <span data-testid="nav-user-name">{user.full_name}</span>
              </span>
              <Button data-testid="nav-logout" variant="ghost" size="sm" onClick={handleLogout}>
                <SignOut size={18} className="mr-1" /> Sortir
              </Button>
            </>
          ) : (
            <>
              <Button data-testid="nav-login" variant="ghost" size="sm" asChild>
                <Link to="/login">Connexion</Link>
              </Button>
              <Button data-testid="nav-signup" size="sm" className="bg-[#E11D48] hover:bg-[#BE123C] text-white" asChild>
                <Link to="/signup">Commencer</Link>
              </Button>
            </>
          )}
        </div>
      </div>
    </header>
  );
};

export default Navbar;
